export const resolveUploadPreviewUrls = (
  markdown: string,
  uploadIdsToPreviewUrls?: Record<string, string>,
): string => {
  if (!uploadIdsToPreviewUrls) return markdown

  return Object.entries(uploadIdsToPreviewUrls).reduce((acc, [id, url]) => {
    const regex = new RegExp(`/(${id})(?![a-zA-Z0-9_-])`, 'g')
    return acc.replace(regex, url)
  }, markdown)
}
